<template>
<div class="warp">
    <div class="loading-wrap" >
        <div :id="LoadingId" :style="multiple"  class="loadingid"></div>
        <span >加载中...</span>
    </div>
</div>
    
</template>

<script>
import lottie from "lottie-web"

import animationData from '../../assets/lottie/animation/loading.json'
export default {
    props:{
        LoadingId:{
            type:String,
            
        },
        scale:{
            type:Number,
            default:1
        }
    },
    computed:{
        multiple(){
            return `transform: scale(${this.scale * 0.5});`
        }
    },
    mounted() {
        // 解决json动画找不到dom不渲染问题
        window.requestAnimationFrame(this.loadImg);
    },
    methods: {
        loadImg () {
            lottie.loadAnimation({
                container: document.getElementById(this.LoadingId),
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: animationData
            });
        }
    }
};
</script>
<style lang="less" scoped>
.warp{
    width: 100%;
    height: 100%;
    position: relative;
}
.loading-wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1800;
    
    .loadingid{
        height: 100%;
        width: 100%;
        
    }
    &>span{
        position: absolute;
        top: 70%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16rem;
        color: #333;
    }
    
}
</style>